<template>
	<db-row width="auto" height="auto" class="dialog-toast-wrapper" :class="toastClass" @click="close(0)" valign="middle" align="center">
		<db-icon v-if="icon" size="48" :icon="icon" class="toast-icon animation-circle" />
		{{message}}
	</db-row>
</template>

<script>
	import {Toast} from '../../../../model/Dialog'
	
	export default {
		props: {
			message: {
				type: [String, Number],
				default: ''
			},
			
			icon: {
				type: String,
				default: ''
			},
			
			time: {
				type: [String, Number, Function],
				default: 2 * (10 ** 3)
			}
		},
		
		data(){
			return {
				timer: null,
				toastClass: 'toast-init'
			}
		},
		
		mounted(){
			this.start()
		},
		
		methods: {
			async start(){
				return new Promise((res) => {
					setTimeout(async () => {
						this.toastClass = 'toast-active'
						await this.close()
						res()
					}, 50)
				})
			},
			
			async close(time){
				this.clear()
				return new Promise((res) => {
					if(typeof this.time === 'function'){
						this.time(() => {
							this.toastClass = 'toast-init'
							setTimeout(() => {
								this.$store.commit('mobileStore/removeDialog')
								res()
							} ,300)
						})
					}else{
						this.timer = setTimeout(() => {
							this.toastClass = 'toast-init'
							setTimeout(() => {
								this.$store.commit('mobileStore/removeDialog')
								res()
							} ,300)
						}, time !== undefined ? time : this.time)
					}
				})
			},
			
			clear(){
				this.timer && window.clearTimeout(this.timer)
			}
		},
		
		beforeDestroy(){
			this.clear()
		}
	}
</script>

<style lang="scss" type="text/scss">
	.dialog-toast-wrapper{
		padding: 30px 40px;
		color: #fff;
		background: rgba(#000, .9);
		border-radius: 20px;
		transition: all .2s;
		font-size: 32px;
		
		&.toast-init{
			opacity: 0;
			transform: scale(0);
		}
		&.toast-active{
			opacity: 1.0;
			transform: scale(1.0);
		}
		
		.toast-icon{
			margin-bottom: 12px;
		}
	}
</style>
